import React, { useEffect, useState } from "react";
import { Stack } from "react-bootstrap";
import { useAtomValue } from "jotai";
import { useTranslation } from "react-i18next";

import "./CreateUserNamePage.scss";
import PrimaryActionButton from "../../../components/Buttons/PrimaryActionButton/PrimaryActionButton";
import { CustomSpinner } from "../../../components/CustomSpinner/CustomSpinner";
import AvatarSection from "../../../components/create-username-page/AvatarSection/AvatarSection";
import { userProfileAtom } from "../../../jotai/atoms/user";
import OnboardingContainer from "../../../components/onboarding/OnboardingContainer/OnboardingContainer";
import UsernameInput, {
  UsernameUpdateOrigin,
} from "../../../components/create-username-page/UsernameInput/UsernameInput";
import useAnalytics from "../../../hooks/useAnalytics";

function CreateUserNamePage() {
  const { t } = useTranslation("common", { keyPrefix: "onboarding" });
  const [isLoading, setIsLoading] = useState(false);
  const userProfile = useAtomValue(userProfileAtom);
  const [username, setUsername] = useState(userProfile?.username ?? "");
  const { sendClaimUsernameScreenEvent } = useAnalytics();

  useEffect(() => {
    sendClaimUsernameScreenEvent();
  }, [sendClaimUsernameScreenEvent]);

  // Update username state when userProfile is updated
  useEffect(() => {
    if (!userProfile?.username || !!username) return;
    setUsername(userProfile.username);
  }, [username, userProfile?.username]);

  return (
    <OnboardingContainer className="d-flex flex-column create-username-page justify-content-between">
      <Stack
        gap={3}
        className="justify-content-center align-items-center create-username-content"
      >
        <AvatarSection />
        <UsernameInput
          username={username}
          setUsername={setUsername}
          setIsLoading={setIsLoading}
          focusInputOnMount={true}
          origin={UsernameUpdateOrigin.ONBOARDING}
        />
      </Stack>
      <PrimaryActionButton
        type="submit"
        form="username-form"
        size="lg"
        text={
          <>
            {isLoading && <CustomSpinner size="sm" />}
            {t("claim_username")}
          </>
        }
        disabled={isLoading || !username}
      />
    </OnboardingContainer>
  );
}

export default CreateUserNamePage;
